import { OrdersRatingStore } from '../OrdersRatingScreen/store/ordersRatingStore';
import { SCREENS } from '~/constants/screens';
import { OrdersHistoryStore } from '~/mobx/ordersHistoryStore/ordersHistoryStore';
import { CallCenterStore } from '~/mobx/ordersStore/callCenterStore';
import { LiveOrdersStore } from '~/mobx/ordersStore/liveOrdersStore';

export enum LOGS {
  TECHNICAL,
  STATUSES,
  TRANSACTIONS,
  CONTENTS,
}

const getOrderLogPath = (parentStore: LiveOrdersStore | CallCenterStore | OrdersHistoryStore | OrdersRatingStore, path: LOGS, orderId: string) => {
  if (parentStore instanceof LiveOrdersStore) {
    const paths = {
      [LOGS.TECHNICAL]: SCREENS.LIVE_ORDER_TECHNICAL_LOGS(orderId),
      [LOGS.STATUSES]: SCREENS.LIVE_ORDER_LOGS(orderId),
      [LOGS.TRANSACTIONS]: SCREENS.LIVE_ORDER_TRANSACTION_LOGS(orderId),
      [LOGS.CONTENTS]: SCREENS.LIVE_ORDER_CONTENT_LOGS(orderId),
    };
    return paths[path];
  }

  if (parentStore instanceof CallCenterStore) {
    const paths = {
      [LOGS.TECHNICAL]: SCREENS.CALLCENTER_ORDER_TECHNICAL_LOGS(orderId),
      [LOGS.STATUSES]: SCREENS.CALLCENTER_ORDER_LOGS(orderId),
      [LOGS.TRANSACTIONS]: SCREENS.CALLCENTER_ORDER_TRANSACTION_LOGS(orderId),
      [LOGS.CONTENTS]: SCREENS.CALLCENTER_ORDER_CONTENT_LOGS(orderId),
    };
    return paths[path];
  }

  if (parentStore instanceof OrdersHistoryStore) {
    const paths = {
      [LOGS.TECHNICAL]: SCREENS.HISTORY_ORDER_TECHNICAL_LOGS(orderId),
      [LOGS.STATUSES]: SCREENS.HISTORY_ORDER_LOGS(orderId),
      [LOGS.TRANSACTIONS]: SCREENS.HISTORY_ORDER_TRANSACTION_LOGS(orderId),
      [LOGS.CONTENTS]: SCREENS.HISTORY_ORDER_CONTENT_LOGS(orderId),
    };
    return paths[path];
  }
  if (parentStore instanceof OrdersRatingStore) {
    const paths = {
      [LOGS.TECHNICAL]: SCREENS.ORDER_RATING_ORDER_TECHNICAL_LOGS(orderId),
      [LOGS.STATUSES]: SCREENS.ORDER_RATING_ORDER_LOGS(orderId),
      [LOGS.TRANSACTIONS]: SCREENS.ORDER_RATING_ORDER_TRANSACTION_LOGS(orderId),
      [LOGS.CONTENTS]: SCREENS.ORDER_RATING_ORDER_CONTENT_LOGS(orderId),
    };
    return paths[path];
  }

  return SCREENS.ROOT();
};

export default getOrderLogPath;
